import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { FormGroup, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { FieldType, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { FormlyFieldProps } from '@ngx-formly/material/form-field';
import { SphereJSONSchemaObject } from '../formly-control-builder.models';
import { FormlyControlBuilderService } from '../formly-control-builder.service';
import { map, tap } from 'rxjs/operators';

export type FormlyFormGroupFieldConfig = FormlyFieldConfig<
    FormlyFieldProps & {
        schema: SphereJSONSchemaObject;
    }
>;

@Component({
    templateUrl: './formly-form-group.component.html',
    styleUrls: ['./formly-form-group.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'mat-elevation-z4'
    },
    imports: [FormlyModule]
})
export class FormlyFormGroupComponent extends FieldType<FormlyFormGroupFieldConfig> implements OnInit {
    private formlyBuilder = inject(FormlyControlBuilderService);

    public formGroup!: UntypedFormGroup;
    public fields: FormlyFieldConfig[] = [];
    ngOnInit() {
        this.formGroup = new FormGroup({});

        this.init(this.props.schema, this.formControl.value);

        this.formGroup.valueChanges
            .pipe(
                tap(v => {
                    console.debug(v);
                    this.formControl.setValue(v);
                })
            )
            .subscribe();

        this.formGroup.statusChanges
            .pipe(
                tap(v => {
                    if (v !== 'VALID') {
                        this.formControl.setErrors({ hasNestedErrors: true });
                    } else {
                        this.formControl.setErrors(null);
                    }
                })
            )
            .subscribe();
    }

    private init(schema: SphereJSONSchemaObject, formState: any) {
        if (formState) {
            this.fields = this.fieldsForGroup(this.props.schema as SphereJSONSchemaObject, formState) as any;
            this.formGroup = this.getControlGroup(formState);
        } else {
            this.fields = this.fieldsForGroup(this.props.schema as SphereJSONSchemaObject) as any;
            this.formGroup = this.getControlGroup();
        }
    }

    private getControlGroup(state?: any): UntypedFormGroup {
        const schema = this.props.schema;
        const controls = {};
        for (const [key, itemSchema] of Object.entries((schema as SphereJSONSchemaObject).properties)) {
            const validators = [];
            let value: any;
            if (state && Object.prototype.hasOwnProperty.call(state, key)) {
                value = state[key];
            } else if (Object.prototype.hasOwnProperty.call(itemSchema, 'default')) {
                value = (itemSchema as any)?.default;
            }
            (controls as any)[key] = new UntypedFormControl(value);
        }
        return new UntypedFormGroup(controls);
    }

    public fieldsForGroup(itemSchema: SphereJSONSchemaObject, state?: any) {
        const fields = [];
        for (const [key, schema] of Object.entries(itemSchema.properties)) {
            const field = this.formlyBuilder.buildControl(key, itemSchema.required, schema, state?.[key]) || { className: '' };
            field.className = 'flex-1';
            fields.push(field);
        }
        return [
            {
                fieldGroupClassName: 'display-flex column-gap--10',
                fieldGroup: fields
            }
        ];
    }

    public modelChange(value: any) {
        console.debug(value);
        this.formGroup.patchValue(value);
    }
}
